var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.50486V2.24514C20 1.00486 18.9951 0 17.7549 0H13.4951C12.2549 0 11.25 1.00486 11.25 2.24514V6.55903C11.25 6.70417 11.1924 6.84306 11.0896 6.94583L6.94583 11.0896C6.84306 11.1924 6.70417 11.25 6.55903 11.25H2.24514C1.00486 11.25 0 12.2549 0 13.4951V17.7549C0 18.9951 1.00486 20 2.24514 20H6.50486C7.74514 20 8.75 18.9951 8.75 17.7549V13.441C8.75 13.2958 8.80764 13.1569 8.91042 13.0542L13.0542 8.91042C13.1569 8.80764 13.2958 8.75 13.441 8.75H17.7549C18.9951 8.75 20 7.74514 20 6.50486Z",
    fill: "#89A0BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabIcon1);
export default __webpack_public_path__ + "static/media/tab_icon_1.5cfbce732515125846f296ee2d223832.svg";
export { ForwardRef as ReactComponent };